export function $agentRole(role: string | undefined | null) {
    return (
        {
            ROLE_AGENT: "Agent",
            ROLE_ADMIN: "Admin",
            ROLE_MODERATOR: "Moderator",
        }[role ?? ""] ?? role
    )
}
